import * as React from "react";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkText } from "uitk-react-text";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { UitkSpacing } from "uitk-react-spacing";

export const CitiCardTierText = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  if (items.length === 0 || items.length !== 1) {
    return null;
  }

  return (
    <div>
      <UitkText align="center" size={400} weight="bold">
        <UitkSpacing padding={{ blockend: "two" }}>
          <div dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
        </UitkSpacing>
      </UitkText>
    </div>
  );
};

export default CitiCardTierText;
